import React from 'react'

const House = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 15.1875V7.875H3.375V15.1875C3.375 15.3367 3.43426 15.4798 3.53975 15.5852C3.64524 15.6907 3.78832 15.75 3.9375 15.75H14.0625C14.2117 15.75 14.3548 15.6907 14.4602 15.5852C14.5657 15.4798 14.625 15.3367 14.625 15.1875V7.875H15.75V15.1875C15.75 15.6351 15.5722 16.0643 15.2557 16.3807C14.9393 16.6972 14.5101 16.875 14.0625 16.875H3.9375C3.48995 16.875 3.06072 16.6972 2.74426 16.3807C2.42779 16.0643 2.25 15.6351 2.25 15.1875ZM14.625 2.8125V6.75L12.375 4.5V2.8125C12.375 2.66332 12.4343 2.52024 12.5398 2.41475C12.6452 2.30926 12.7883 2.25 12.9375 2.25H14.0625C14.2117 2.25 14.3548 2.30926 14.4602 2.41475C14.5657 2.52024 14.625 2.66332 14.625 2.8125Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20466 1.68748C8.41563 1.47657 8.70173 1.35809 9.00004 1.35809C9.29835 1.35809 9.58444 1.47657 9.79541 1.68748L17.2733 9.16423C17.3789 9.26985 17.4382 9.41311 17.4382 9.56248C17.4382 9.71185 17.3789 9.85511 17.2733 9.96073C17.1677 10.0664 17.0244 10.1257 16.875 10.1257C16.7257 10.1257 16.5824 10.0664 16.4768 9.96073L9.00004 2.48285L1.52329 9.96073C1.41767 10.0664 1.27441 10.1257 1.12504 10.1257C0.975666 10.1257 0.832412 10.0664 0.726789 9.96073C0.621167 9.85511 0.561829 9.71185 0.561829 9.56248C0.561829 9.41311 0.621167 9.26985 0.726789 9.16423L8.20466 1.68748Z"
        fill="white"
      />
    </svg>
  )
}

export default House;